import React, {Fragment} from "react";
import Icon from "../../../Icon";
import Confirm from "../../../Confirm";
import {UrlGenerator} from "../../../../../utils/request";
import {GUIProps} from "../Table/Types/GUIProps";
import CheckBox from "../../../CheckBox";
import isEqual from "lodash-es/isEqual";

export default class ExcelExport extends React.Component<GUIProps&{actionButton: typeof React.Component}, any> {

    constructor(props: GUIProps&{actionButton: typeof React.Component}) {
        super(props);
        this.state = {
            visibleFields: this.props.visibleFields,
            allPages: false,
        }
    }

    componentDidUpdate(prevProps: Readonly<GUIProps>, prevState: Readonly<any>, snapshot?: any) {
        if (!isEqual(this.props.visibleFields, prevProps.visibleFields) || !isEqual(Object.keys(this.props.getFields({onlyVisible: true})), Object.keys(prevProps.getFields({onlyVisible: true})))) {
            this.setState({
                visibleFields: this.props.visibleFields
            });
        }
    }

    render() {
        let visibleFields = this.state.visibleFields;
        let fields = this.props.getFields({onlyVisible: true});
        //let data = this.props.data;
        return (
            <Confirm
                size="large"
                header={<Fragment><Icon lib="far" name="file-excel" /> Excel export</Fragment>}
                body={<div className="row">
                    {fields.map((Column, idx) => {
                        if (Column.props.label === false) {
                            return null;
                        }
                        if (Column.props.exportable === undefined || Column.props.exportable === true) {
                            let field = Column.props.field;
                            let selectedIndex = visibleFields.indexOf(field);

                            let column = this.props?.data?.columns?.[field]?.label;
                            let label = column === field ? null : column;

                            return <div key={idx} className="col">
                                <div className="form-group">
                                    <CheckBox
                                        value="1"
                                        label={label || Column.props.header || column || field}
                                        checked={selectedIndex !== -1}
                                        saveChanges={() => {
                                            let newVisibleFields = [...visibleFields];
                                            if (selectedIndex !== -1) {
                                                newVisibleFields.splice(selectedIndex, 1);
                                            } else {
                                                newVisibleFields.push(field);
                                            }
                                            this.setState({
                                                visibleFields: newVisibleFields
                                            })
                                        }}
                                    />
                                </div>
                            </div>
                        }
                    }).filter(Boolean)}
                </div>}
                footer={[
                    this.props.request.itemsperpage > 0 ?<div className="pull-left">
                        <CheckBox
                            className="my-0"
                            value="1"
                            label="Összes oldal"
                            checked={this.state.allPages}
                            saveChanges={() => {
                                this.setState({
                                    allPages: !this.state.allPages
                                })
                            }}
                        />
                    </div> : null
                ].filter(Boolean)}
                onAccept={() => {
                    let url = UrlGenerator();
                    delete url.fragment;

                    let request = {...this.props.request};
                    request.resptype = "excel";
                    request.view = this.state.visibleFields;
                    if (request.itemsperpage > 0 && this.state.allPages) {
                        request.page = 1;
                        request.itemsperpage = 0;
                    }

                    url.query = request;
                    window.open(url.toString(), "_blank");
                }}
                acceptButton="Letöltés"
            >
                <this.props.actionButton>
                    <span className="nowrap"><Icon lib="far" name="file-excel" /> Excel export</span>
                </this.props.actionButton>
            </Confirm>
        );
    }
}
